import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { normalizePhoneNumber } from "../helper/normalizePhoneNumber";

export const useLoginValidation = () => {
  const { t } = useTranslation("login");
  const loginValidationSchema = yup.object({
    identifier: yup
      .string().trim()
      .required(t("formErrors.identifier.required"))
      .test(
        "email-or-phone",
        t("formErrors.identifier.invalid"),
        function (value) {
          const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

          if (emailRegex.test(value)) {
            return true; // Valid email
          }

          const phoneNumber = normalizePhoneNumber(
            this.parent.countryCode,
            value
          );

          return /^\+[1-9]\d{7,14}$/.test(phoneNumber);
        }
      ),
    password: yup
      .string()
      .required(t("formErrors.password.required"))
      .min(8, t("formErrors.password.minLength"))
      .matches(
        /^(?=.*?[A-Za-z])(?=.*?[0-9]).{8,}$/,
        t("formErrors.password.invalidFormat")
      ),
    countryCode: yup.string().when("identifier", {
      is: (identifier) => /^\d+$/.test(identifier),
      then: (schema) => schema.required(t("formErrors.countryCode.required")),
    }),
  });
  return { loginValidationSchema };
};
